import { useMutation } from '@tanstack/react-query';

import { fetchListFourApi } from '../api';

export default function useListFourMutation(options?: any) {
  return useMutation(fetchListFourApi, options);
}
